export interface IGlobalState {
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  actionConfirmedText;
}

export type IGlobalSelector = IGlobalState

export enum GlobalActionTypes {
  GLOBAL_LOAD_REQUESTED = 'redux-app/global/GLOBAL_LOAD_REQUESTED',
  GLOBAL_LOAD_PENDING = 'redux-app/global/GLOBAL_LOAD_PENDING',
  GLOBAL_LOAD_FINISHED = 'redux-app/global/GLOBAL_LOAD_FINISHED',
  PERSIST_HYDRATED = 'persist/REHYDRATE',
}

export default null;
